import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import App from './App';
import { AuthProviderContainer } from './context/auth';
import { ToastContextProvider } from './context/toast';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { GlobalProviderContainer } from './context/globalContext';

// const queryClient = new QueryClient({
//   defaultOptions: {
//     queries: {
//       refetchOnWindowFocus: false, // Disable refetching on window focus
//       refetchOnReconnect: false, // Disable refetching on network reconnect
//       staleTime: Infinity, // Prevent queries from becoming stale
//       cacheTime: 0, // Do not cache query data
//     },
//     mutations: {
//       // You can also set mutation defaults here
//     },
//   },
// });

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastContextProvider>
        <AuthProviderContainer>
          <GlobalProviderContainer>
            <App />
          </GlobalProviderContainer>
        </AuthProviderContainer>
      </ToastContextProvider>
      <ReactQueryDevtools initialIsOpen={true} />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
